/**
 * @file browser-decorator
 * @description 浏览器装饰器插件
 */

import {addEvent} from '@/utils/decorate/event';

export default {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    // 域名获取
                    origin: window.location.origin
                };
            },
            watch: {
                $route(to, from) {
                    this.watchHandler(to, from);
                }
            },
            methods: {

                /**
                 * 全局点击事件绑定
                 *
                 * @param {Function} callback 回调函数
                 */
                globalClick(callback) {
                    addEvent(document, 'click', e => {
                        callback(e.target);
                    });
                },
                watchHandler() {}
            }
        });
    }
};
